import type { AdminUserRolesByScope } from "../api/AdminUserAPI.types";

export const OWNER = "owner";
export const EDITOR_ADMIN = "editor_admin";
export const PROJECT_ADMIN = "project_admin";
export const CONTENT_MANAGER_ADMIN = "content_manager_admin";
export const CONTENT_MANAGER = "content_manager";
export const EDITORIAL_MANAGER = "editorial_manager";
export const BUSINESS_MANAGER = "business_manager";
export const ANALYST_ADMIN = "analyst_admin";
export const ANALYST = "analyst";
export const MODERATOR_ADMIN = "moderator_admin";
export const MODERATOR = "moderator";
export const FAST_ADMIN = "fast_admin";
export const FAST_ANALYST = "fast_analyst";

export const DEFAULT_USER_ROLE_BY_SCOPE: AdminUserRolesByScope = {
  organization: [],
  fast_channels: [],
  storefront_projects: [],
};

export type Role =
  | typeof BUSINESS_MANAGER
  | typeof OWNER
  | typeof EDITOR_ADMIN
  | typeof PROJECT_ADMIN
  | typeof CONTENT_MANAGER_ADMIN
  | typeof CONTENT_MANAGER
  | typeof EDITORIAL_MANAGER
  | typeof ANALYST_ADMIN
  | typeof ANALYST
  | typeof MODERATOR_ADMIN
  | typeof MODERATOR
  | typeof FAST_ADMIN
  | typeof FAST_ANALYST;
